__turbopack_export_value__({
  "arrow": "selectSpecialization-module-scss-module__Wm2cCq__arrow",
  "arrowUp": "selectSpecialization-module-scss-module__Wm2cCq__arrowUp",
  "body-logo-18": "selectSpecialization-module-scss-module__Wm2cCq__body-logo-18",
  "body-text-12": "selectSpecialization-module-scss-module__Wm2cCq__body-text-12",
  "body-text-14": "selectSpecialization-module-scss-module__Wm2cCq__body-text-14",
  "body-text-16": "selectSpecialization-module-scss-module__Wm2cCq__body-text-16",
  "body-text-18": "selectSpecialization-module-scss-module__Wm2cCq__body-text-18",
  "body-text-20": "selectSpecialization-module-scss-module__Wm2cCq__body-text-20",
  "body-text-24": "selectSpecialization-module-scss-module__Wm2cCq__body-text-24",
  "body-text-24-2": "selectSpecialization-module-scss-module__Wm2cCq__body-text-24-2",
  "body-text-heading-2": "selectSpecialization-module-scss-module__Wm2cCq__body-text-heading-2",
  "body-text-heading-3": "selectSpecialization-module-scss-module__Wm2cCq__body-text-heading-3",
  "body-text-medium-14": "selectSpecialization-module-scss-module__Wm2cCq__body-text-medium-14",
  "body-text-medium-16": "selectSpecialization-module-scss-module__Wm2cCq__body-text-medium-16",
  "body-text-medium-18": "selectSpecialization-module-scss-module__Wm2cCq__body-text-medium-18",
  "body-text-medium2-18": "selectSpecialization-module-scss-module__Wm2cCq__body-text-medium2-18",
  "body-text2-14": "selectSpecialization-module-scss-module__Wm2cCq__body-text2-14",
  "body-text2-16": "selectSpecialization-module-scss-module__Wm2cCq__body-text2-16",
  "button-primary-text": "selectSpecialization-module-scss-module__Wm2cCq__button-primary-text",
  "button-text": "selectSpecialization-module-scss-module__Wm2cCq__button-text",
  "button2-text": "selectSpecialization-module-scss-module__Wm2cCq__button2-text",
  "card-shadow": "selectSpecialization-module-scss-module__Wm2cCq__card-shadow",
  "dropdownContainer": "selectSpecialization-module-scss-module__Wm2cCq__dropdownContainer",
  "dropdownMenu": "selectSpecialization-module-scss-module__Wm2cCq__dropdownMenu",
  "dropdownMenuItem": "selectSpecialization-module-scss-module__Wm2cCq__dropdownMenuItem",
  "effect-menu": "selectSpecialization-module-scss-module__Wm2cCq__effect-menu",
  "header-1": "selectSpecialization-module-scss-module__Wm2cCq__header-1",
  "main-container": "selectSpecialization-module-scss-module__Wm2cCq__main-container",
  "main-footer-container": "selectSpecialization-module-scss-module__Wm2cCq__main-footer-container",
  "main-header-container": "selectSpecialization-module-scss-module__Wm2cCq__main-header-container",
  "selected": "selectSpecialization-module-scss-module__Wm2cCq__selected",
  "toggleDropdown": "selectSpecialization-module-scss-module__Wm2cCq__toggleDropdown",
  "txt-12-bold": "selectSpecialization-module-scss-module__Wm2cCq__txt-12-bold",
  "txt-14-bold": "selectSpecialization-module-scss-module__Wm2cCq__txt-14-bold",
  "txt-14-bold-caps": "selectSpecialization-module-scss-module__Wm2cCq__txt-14-bold-caps",
  "txt-14-med": "selectSpecialization-module-scss-module__Wm2cCq__txt-14-med",
  "txt-16-bold": "selectSpecialization-module-scss-module__Wm2cCq__txt-16-bold",
  "txt-16-med": "selectSpecialization-module-scss-module__Wm2cCq__txt-16-med",
  "txt-18-bold": "selectSpecialization-module-scss-module__Wm2cCq__txt-18-bold",
  "txt-18-medium": "selectSpecialization-module-scss-module__Wm2cCq__txt-18-medium",
  "txt-18-medium-24": "selectSpecialization-module-scss-module__Wm2cCq__txt-18-medium-24",
  "txt-24-semi": "selectSpecialization-module-scss-module__Wm2cCq__txt-24-semi",
});
